const styles = theme => ({
  imageContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  imageHeader: {
    color: 'var(--mcg-dark, #002E47)',
    /* Body/Body 4 */
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 21px */,
  },
  imageText: {
    color: 'var(--mcg-gray, #919EAB)',
    /* Body/Body 6 */
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '18px' /* 163.636% */,
  },
  positionContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch',
  },
  positionContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  positionDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
    flex: '1 0 0',
  },
  positionTextDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  positionText: {
    overflow: 'hidden',
    color: 'var(--mcg-dark, #002E47)',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    /* Body/Body 6 */
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '18px' /* 163.636% */,
  },
})

export default styles
